import { render, staticRenderFns } from "./idCardUpload.vue?vue&type=template&id=398f4c8a&scoped=true"
import script from "./idCardUpload.vue?vue&type=script&lang=js"
export * from "./idCardUpload.vue?vue&type=script&lang=js"
import style0 from "./idCardUpload.vue?vue&type=style&index=0&id=398f4c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f4c8a",
  null
  
)

export default component.exports